export const useShopifyCheckoutURL = {
    active: false,
    url: '',
};

export const addToBasketButtonName = {//if default is false, change the name of the add to basket button
    default: true,
    name: ""
};

export const continueToCheckoutButtonName = "Continue to Checkout"; // change the button name for continue to checkout
export const continueToShoppingButtonName = {
    enabled: false,
    text: "Continue shopping"
};


export const pickeasy = {
    enabled: false,
    textButtonCart: "When Would You Like to Get This Order?",
    urlApi: "https://slots-app.logbase.io/api/slots",
    textDelivery: "Local Delivery",
    textPickup: "Store Pickup",
    inicialOption: "shipping"// pickup, shipping,delivery
}

export const deliveryExtraInformation = false;

export const defaultMarketCountry = {
    enabled: false,
    code: "GB"
}